const flickityRef = (() => {

    var flickitySlider = document.getElementsByClassName('referenzCarousel');
    if (flickitySlider.length > 0) {

        // external js: flickity.pkgd.js
        var utils = window.fizzyUIUtils;

        var referenzCarousel = document.querySelector('.referenzCarousel');
        var flkty = new Flickity( referenzCarousel, {
            pageDots: true,
            prevNextButtons: false,
            cellSelector: '.carousel-cell'
        });


        // previous
        var previousButton = document.querySelector('.button--previous');
        previousButton.addEventListener( 'click', function() {
            flkty.previous();
        });
        // next
        var nextButton = document.querySelector('.button--next');
        nextButton.addEventListener( 'click', function() {
            flkty.next();
        });        
    }
  
  
    var flickitySlider = document.getElementsByClassName('kundenCarousel');
    if (flickitySlider.length > 0) {

        // external js: flickity.pkgd.js
        var utils = window.fizzyUIUtils;

        var kundenCarousel = document.querySelector('.kundenCarousel');
        var flkty = new Flickity( kundenCarousel, {
            pageDots: true,
            autoPlay: 3000,
            prevNextButtons: false,
            wrapAround: true,
            cellSelector: '.carousel-cell'
        });

    }

})();
  
export default flickityRef;